import React from 'react';
import { steps } from '../data/services';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';

export default function Process() {
  return (
    <section className="section">
      <div className="container">
        <SectionHeading center eyebrow="How We Work" title="From idea to dependable platform" />
        <ol className="process">
          {steps.map((s, i) => (
            <Reveal as="li" key={s.n} delay={i * 100} className="process__step">
              <span className="process__n">{s.n}</span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
